import React, { useEffect, forwardRef, MutableRefObject } from 'react'
import styled from 'styled-components'

type CheckboxProps = {
  indeterminate?: boolean
  disabled?: boolean
}

const useCombinedRefs = (...refs: any): MutableRefObject<any> => {
  const targetRef = React.useRef()
  React.useEffect(() => {
    refs.forEach((ref: any) => {
      if (!ref) return

      if (typeof ref === 'function') {
        ref(targetRef.current)
      } else {
        // eslint-disable-next-line no-param-reassign
        ref.current = targetRef.current
      }
    })
  }, [refs])

  return targetRef
}

// eslint-disable-next-line react/display-name
const IndeterminateCheckbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ indeterminate, ...rest }: CheckboxProps, ref: React.Ref<HTMLInputElement>) => {
    const defaultRef = React.useRef(null)
    const combinedRef = useCombinedRefs(ref, defaultRef)

    useEffect(() => {
      if (combinedRef?.current) {
        combinedRef.current.indeterminate = indeterminate ?? false
      }
    }, [combinedRef, indeterminate])

    return (
      <TableCheckbox>
        <StyledCheckbox type="checkbox" ref={combinedRef} {...rest} />
      </TableCheckbox>
    )
  },
)

export const StyledCheckbox = styled.input`
  height: 15px;
  width: 15px;
`

const TableCheckbox = styled.div`
  display: inline-block;
`

export default IndeterminateCheckbox
